import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import store from '../redux/store';

import Employers from './adminData/employers/EmployersComponent';
import EmployerManagement from "./adminData/employers/EmployerManagementComponent";
import EmployerNew from "./adminData/employers/EmployerNewComponent";
import MyEmployerManagement from "./adminData/employers/MyEmployerComponent"; 
import WorksiteMew from './adminData/employers/WorksiteNewComponent';
import WorksiteManagement from './adminData/employers/WorksiteManagementComponent';
import { RefreshClientsCachedData, RefreshEmployersByEIDCachedData, RefreshEmployersByCIDCachedData, RefreshWorksiteByEIDCachedData } from './AFStoreDataRefresh';
import { DispatchAF } from './AFStoreDispatchAction';
import * as AFStateHelper from './AFStateHelper';
import { ClientType } from "./constants/Consts";
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';

export const EmployersPage = () => {
    const reduxStore = store.getState();

    var dataStatus;
    if( reduxStore.clients.status === ReduxDataStatus.LOADING || reduxStore.clients.status === ReduxDataStatus.IDLE ||
        reduxStore.employers.status === ReduxDataStatus.LOADING || reduxStore.employers.status === ReduxDataStatus.IDLE
    ) {
        
        dataStatus = ReduxDataStatus.LOADING;
    }
    else {
        dataStatus = ReduxDataStatus.SUCCEEDED;
    }

    return(
        <Employers 
            loadComponentData={EmployersDataLoader}
            dataStatus={dataStatus}
            employers={reduxStore.employers} 
            clients={reduxStore.clients}
        />
    );
} 

const EmployersDataLoader = () => {
    console.log('++++ EmployersDataLoader <<')

    const refreshingData = RefreshClientsCachedData();
    if(!refreshingData) {
        const contextClientId = AFStateHelper.getContextClientId();
        const clientType = AFStateHelper.getClientType(contextClientId);
    
        if(clientType === ClientType.Angajator) {
            const myEmployerId = AFStateHelper.getClientEmployerEID(contextClientId);
            RefreshEmployersByEIDCachedData(myEmployerId);
        }
        else if(clientType === ClientType.ServicuExtern) {
            RefreshEmployersByCIDCachedData(contextClientId);
        }
        // else -> we should not be here.....
    }
}


export const EmployerManagementPage = () => {
    const reduxStore = store.getState();
    const { employerId } = useParams();
    const eId = parseInt(employerId, 10)

    return (
        <EmployerManagement
            loadComponentData={EmployerManagementDataLoader}
            dataStatus={reduxStore.employers.status}
            employer={reduxStore.employers.employers.find((employer) => employer.id === eId)}
            patchEmployer={DispatchAF.patchEmployer}
            worksites={reduxStore.worksites.worksites}
            clients={reduxStore.clients.clients}
        />
    );
};

const EmployerManagementDataLoader = (erId) => {
    RefreshWorksiteByEIDCachedData(erId);
}


export const EmployerNewPage = () => {
    const reduxStore = store.getState();
    const contextClientId = AFStateHelper.getContextClientId();

    return (
        <EmployerNew
            postEmployer={DispatchAF.postEmployer}
            clients={ reduxStore.clients.clients.filter((client) => client.id === contextClientId) }
            mostRecentEmployerId={reduxStore.bucket.bucket.mostRecentEmployerId}
        />
    );
}

export const MyEmployerPage = () => {
    const reduxStore = store.getState();
    // Should the client be stored separately ???
    // Should dataStaus take into account the clients reload ???
    const myEmployerId = AFStateHelper.getSiuClientEmployerEID()

    return (
        <MyEmployerManagement
            loadComponentData={MyEmployerManagementDataLoader}
            myEmployerId={myEmployerId}
            dataStatus={reduxStore.employers.status}
            employer={reduxStore.employers.employers.find((employer) => employer.id === myEmployerId)}
            patchEmployer={DispatchAF.patchEmployer}
            worksites={reduxStore.worksites.worksites}
            clients={reduxStore.clients.clients}
        />
    );
}

const MyEmployerManagementDataLoader = (erId) => {
    RefreshEmployersByEIDCachedData(erId);
    RefreshWorksiteByEIDCachedData(erId);
}


export const WorksiteNewPage = () => {
    const reduxStore = store.getState();

    let [searchParams, setSearchParams] = useSearchParams();

    if(reduxStore.bucket.bucket.mostRecentWsId != null) {
        return(
            <Navigate to={`/employers/worksites/${reduxStore.bucket.bucket.mostRecentWsId}`} replace />
        );
    }
    const erId = searchParams.get("employerId");
    const employerId = erId ? parseInt(erId, 10) : null;
    
    const employer= reduxStore.employers.employers.find((employer) => employer.id === employerId);

    return (
        <WorksiteMew
            employer = {employer}
            createWorksite={DispatchAF.postEmployerWorksite}
        />
    );
};


export const WorksiteManagementPage = () => {
    const reduxStore = store.getState();

    const { worksiteId } = useParams();
    const wsId = parseInt(worksiteId, 10)

    const worksite = reduxStore.worksites.worksites.find((worksite) => worksite.id === wsId);
    const employer= reduxStore.employers.employers.find((employer) => employer.id === worksite.generalSection.employerId);

    return (
        <WorksiteManagement
            loadComponentData={WorksiteManagementDataLoader}
            dataStatus={reduxStore.worksites.status}
            worksite = {worksite}
            employer = {employer}
            saveWorksite={DispatchAF.patchEmployerWorksite}

        />
    );
};

const WorksiteManagementDataLoader = (erId) => {
    RefreshWorksiteByEIDCachedData(erId);
}

